__turbopack_context__.v({
  "column": "ProjectsReviews-module-scss-module__ZKn3ia__column",
  "loadingReviewsContainer": "ProjectsReviews-module-scss-module__ZKn3ia__loadingReviewsContainer",
  "mobileView": "ProjectsReviews-module-scss-module__ZKn3ia__mobileView",
  "multiColumn": "ProjectsReviews-module-scss-module__ZKn3ia__multiColumn",
  "ratingBar": "ProjectsReviews-module-scss-module__ZKn3ia__ratingBar",
  "reviewsList": "ProjectsReviews-module-scss-module__ZKn3ia__reviewsList",
  "reviewsWithBorderContainer": "ProjectsReviews-module-scss-module__ZKn3ia__reviewsWithBorderContainer",
  "singleColumn": "ProjectsReviews-module-scss-module__ZKn3ia__singleColumn",
});
